import { createAction, props } from '@ngrx/store'

export enum OrderPaymentMethodTypes {
  TRY_SAVE_CHANGES = '[ORDER PAYMENT METHODS] Try save changes',
  SAVE_CHANGES_SUCCESS = '[ORDER PAYMENT METHODS] Save changes success',
  SAVE_CHANGES_ERROR = '[ORDER PAYMENT METHODS] Save changes fail',
}

export const OrderPaymentMethodActions = {
  trySaveChanges: createAction(
    OrderPaymentMethodTypes.TRY_SAVE_CHANGES,
    props<{ payload: { paymentId: string; subscriptionId: string; sessionId: string } }>(),
  ),
  saveChangesSuccess: createAction(OrderPaymentMethodTypes.SAVE_CHANGES_SUCCESS),
  saveChangesError: createAction(OrderPaymentMethodTypes.SAVE_CHANGES_ERROR),
}
